export const LIST_OF_PERFORMANCE_DATA = [
  {
    formal_name: "Amazon Ads",
    display_name: "Amazon Ads",
    level_needed: "Profile",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{14,16}$", "Account ID must contain only numbers (14-16 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text", // Changed to text
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          default: "purchase",
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Apple Search Ads",
    display_name: "Apple Search Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{6,10}$", "Account ID must contain only numbers (6-10 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          default: "app_installs",
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,

          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Campaign Manager 360",
    display_name: "CM360",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{6,8}$", "Account ID must contain only numbers (6-8 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: false, // N/A is provided, so TBD is not allowed
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: false, // N/A is provided, so TBD is not allowed
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,

          allow_na: false,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Criteo DSP",
    display_name: "Criteo DSP",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{5,6}$", "Account ID must contain only numbers (5-6 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,

          allow_na: false,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Display Video 360",
    display_name: "DV360",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{7,}$", "Account ID must contain only numbers (at least 7 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: false, // N/A is provided, so TBD is not allowed
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: false, // N/A is provided, so TBD is not allowed
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Google Analytics Data",
    display_name: "GA4",
    level_needed: "Property",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{6,}$", "Account ID must contain only numbers (at least 6 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: false, // N/A is provided, so TBD is not allowed
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "dropdown", // Dropdown with options
        options: ["Event Scoped", "Session Scoped"],
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          default: "purchase",
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      property_id: {
        label: "Property ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{9,}$", "Property ID must contain only numbers (at least 9 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      property_name: {
        label: "Property Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_enterprise_client: {
        label: "UTM Level",
        type: "dropdown",
        options: ["All UTMs Level", "Campaign Level UTM"],
        account_config_key: "is_enterprise_client",
        validation: {
          required: false,
          default: "Campaign Level UTM",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Google Ads",
    display_name: "Google Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{10}$", "Account ID must contain only numbers (exactly 10 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "dropdown", // Dropdown with options
        options: ["Ad Action (default)", "Conversion"],
        validation: {
          required: true,
          default: "Ad Action (default)",
          allow_na: false,
          allow_tbd: false,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text", // Single value
        validation: {
          required: false,
          default: "PURCHASE",
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea", // Text type, optional
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Meta Ads",
    display_name: "Meta Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{8,32}$", "Account ID must contain only numbers (8-32 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "nested-dropdown",
        options: [
          "Use unified attribution",
          {
            label: "Define Window",
            value: "define_window",
            children: [
              {
                label: "Click Window",
                type: "dropdown",
                options: [
                  {
                    label: "7 days",
                    value: "7",
                  },
                  {
                    label: "1 day",
                    value: "1",
                  },
                ],
                validation: {
                  required: false,
                },
              },
              {
                label: "View Window",
                type: "dropdown",
                options: [
                  {
                    label: "7 days",
                    value: "7",
                  },
                  {
                    label: "1 day",
                    value: "1",
                  },
                  {
                    label: "0 day",
                    value: "0",
                  },
                ],
                validation: {
                  required: false,
                },
              },
            ],
          },
        ],
        validation: {
          required: false,
          default: "Use unified attribution",
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      is_mbm: {
        label: "Metaplier Access",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_emq: {
        label: "Track EMQ",
        tooltip: "Event Match Quality",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      emq_primary_conversion: {
        label: "Primary Conversion",
        type: "text", // Text type, optional
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
        iButton: true,
      },
      emq_secondary_conversion: {
        label: "Secondary Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
        iButton: true,
      },
      emq_tertiary_conversion: {
        label: "Tertiary Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
        iButton: true,
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          default: ["offline_conversion.purchase", "purchase"],
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea", // Text type, optional
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Microsoft Ads",
    display_name: "Microsoft Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{4,9}$", "Account ID must contain only numbers (4-9 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: {
            dependent_field: "selected_conversion_tag_names",
            required_if_empty: true,
          },
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: {
            dependent_field: "selected_conversion_event",
            required_if_empty: true,
          },
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      keyword_level_needed: {
        label: "Keyword Level Templates Needed",
        type: "dropdown",
        options: ["Yes", "No"],
        account_config_key: "keyword_level_needed",
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Pinterest Ads",
    display_name: "Pinterest Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{12}$", "Account ID must contain only numbers (exactly 12 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "multiple-dropdown", // Single dropdown column
        options: [
          {
            label: "Click",
            value: "click_window",
            children: [
              {
                label: "Click Window",
                type: "dropdown",
                options: [
                  { label: "30 days", value: "30" },
                  { label: "14 days", value: "14" },
                  { label: "7 days", value: "7" },
                  { label: "1 day", value: "1" },
                  { label: "0 days", value: "0" },
                ],
                validation: {
                  required: true,
                  default: "30",
                },
              },
              {
                label: "Engagement Window",
                type: "dropdown",
                options: [
                  { label: "30 days", value: "30" },
                  { label: "14 days", value: "14" },
                  { label: "7 days", value: "7" },
                  { label: "1 day", value: "1" },
                  { label: "0 days", value: "0" },
                ],
                validation: {
                  required: true,
                  default: "30",
                },
              },
              {
                label: "View Window",
                type: "dropdown",
                options: [
                  { label: "30 days", value: "30" },
                  { label: "14 days", value: "14" },
                  { label: "7 days", value: "7" },
                  { label: "1 day", value: "1" },
                  { label: "0 days", value: "0" },
                ],
                validation: {
                  required: true,
                  default: "30",
                },
              },
            ],
          },
        ],
        validation: {
          required: true,
          default: "30/30/30",
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "dropdown", // Dropdown with options
        options: ["Ad Action (default)", "Conversion"],
        validation: {
          required: true,
          default: "Ad Action (default)",
          allow_na: false,
          allow_tbd: false,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text", // Text type, optional
        validation: {
          required: false,
          default: "checkout",
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea", // Text type, optional
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Reddit Ads",
    display_name: "Reddit Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: [
            "^[a-zA-Z0-9_]{11,15}$",
            "Account ID must be alphanumeric with underscores (11-15 characters).",
          ],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text", // Text type, optional
        validation: {
          required: false,
          default: "purchase",
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Snapchat Ads",
    display_name: "Snapchat Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: [
            "^[a-zA-Z0-9-]{36}$",
            "Account ID must be 36 alphanumeric characters with dashes.",
          ],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "multiple-dropdown", // Dropdown with options
        options: [
          {
            label: "Swipe and View Windows",
            value: "swipe_and_view_window", // Assign a value to identify this parent option
            children: [
              {
                label: "Swipe Window",
                type: "dropdown",
                options: [
                  { label: "28 days", value: "28" },
                  { label: "7 days", value: "7" },
                  { label: "1 day", value: "1" },
                ],
                validation: {
                  required: true,
                  default: "7",
                },
              },
              {
                label: "View Window",
                type: "dropdown",
                options: [
                  { label: "28 days", value: "28" },
                  { label: "7 days", value: "7" },
                  { label: "1 day", value: "1" },
                  { label: "0 day", value: "0" },
                ],
                validation: {
                  required: true,
                  default: "1",
                },
              },
            ],
          },
        ],
        validation: {
          required: true,
          default: "7/1",
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "dropdown", // Dropdown with options
        options: ["Conversion (default)", "Impression"],
        validation: {
          required: true,
          default: "Conversion (default)",
          allow_na: false,
          allow_tbd: false,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text", // Text type, optional
        validation: {
          required: false,
          default: "purchases",
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "TikTok Ads",
    display_name: "TikTok Ads",
    level_needed: "Account",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: ["^\\d{19}$", "Account ID must contain only numbers (exactly 19 digits)."],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text", // Text type, optional
        validation: {
          required: false,
          default: "complete_payment",
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "theTradeDesk",
    display_name: "theTradeDesk",
    level_needed: "Advertiser",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: [
            "^[a-zA-Z0-9]{7}$",
            "Account ID must be 7 alphanumeric characters.",
          ],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: {
            dependent_field: "selected_conversion_tag_names",
            required_if_empty: true,
          },
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: {
            dependent_field: "selected_conversion_event",
            required_if_empty: true,
          },
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "AppLovin",
    display_name: "AppLovin",
    level_needed: "Other",
    fields: {
      account_id: {
        label: "AppLovin Account ID",
        type: "text",
        validation: {
          required: true,
          pattern: [
            "^applovin_.+$",
            "Account ID must start with applovin_ followed by client name.",
          ],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
          default: "TBD",
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
          default: "TBD",
        },
      },
    },
  },
  {
    formal_name: "AppsFlyer",
    display_name: "AppsFlyer",
    level_needed: "App ID",
    fields: {
      account_id: {
        label: "AppsFlyer App ID",
        type: "text",
        validation: {
          required: true,
          pattern: [
            "^appsflyer_.+$",
            "Account ID must start with appsflyer_ followed by app ID.",
          ],
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "App Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
          default: "TBD",
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
          default:
            "Need to append appsflyer to the ID, otherwise, it will not be unique enough, as app_id can be used elsewhere.",
        },
      },
    },
  },
  {
    formal_name: "Client System",
    display_name: "Client System",
    type: "Free Form Text",
    level_needed: "Varies",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          // pattern: [
          //   "^[a-zA-Z0-9 ]+_[a-zA-Z0-9 ]+$",
          //   "Account Id should be {systemname}_{clientname}",
          // ], // Pattern for concatenated system name and client name
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Shopify",
    display_name: "Shopify",
    level_needed: "Varies",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          // pattern: ["^.*$", "No Validation"], // Pattern for concatenated system name and client name
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      property_id: {
        label: "Shopify Domain Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
  {
    formal_name: "Other",
    display_name: "Other",
    level_needed: "Varies",
    type: "Free Form Text",
    fields: {
      account_id: {
        label: "Account ID",
        type: "text",
        validation: {
          required: true,
          // pattern: ["^.*$", "No Validation"], // Pattern for concatenated system name and client name
          allow_na: false,
          allow_tbd: false,
        },
      },
      account_name: {
        label: "Account Name",
        type: "text",
        validation: {
          required: true,
          allow_na: false,
          allow_tbd: false,
        },
      },
      attribution_window: {
        label: "Attribution Window",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      attribution_basis: {
        label: "Attribution Basis",
        type: "text",
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_event: {
        label: "Selected Conversion Event",
        type: "text",
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },

      currency_conversion: {
        label: "Currency Conversion",
        type: "text", // Text type, optional
        validation: {
          required: false,
          allow_na: true,
          allow_tbd: true,
        },
      },
      selected_conversion_tag_names: {
        label: "Selected Conversion Tag Name(s)",
        type: "array", // Array of strings (multi-value field)
        validation: {
          required: false,
          allow_na: false,
          allow_tbd: false,
        },
      },
      backfill_status: {
        label: "Backfill Status",
        type: "dropdown",
        options: ["No Access", "Pending", "Running", "Completed", "Error"],
        validation: {
          required: false,
          default: "Pending",
        },
      },
      source_of_truth: {
        label: "Primary",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      is_automation_enabled: {
        label: "Automation Enabled",
        type: "switch",
        options: ["Yes", "No"],
        validation: {
          required: false,
          default: "No",
          allow_na: false,
          allow_tbd: false,
        },
      },
      notes: {
        label: "Notes",
        type: "textarea",
        validation: {
          required: false,
        },
      },
    },
  },
];
